/** Statusi koji više ne opterećuju poslovanje. */
export const WORKLOAD_CLOSED_STATUSES = ['Completed', 'Cancelled', 'Archived'];

/** Statusi poslova u arhivi (nisu u sekciji Novi poslovi). */
export const ARCHIVE_JOB_STATUSES = ['Completed', 'Finished', 'Archived'];

/** Poslovi za koje je dozvoljena rezervacija robe (kalendar, nezakazani, prosleđeni). */
export const isOpenJobForReservation = (job) => {
  if (!job) return false;
  if (ARCHIVE_JOB_STATUSES.includes(job.status)) return false;
  if (job.status === 'Cancelled') return false;
  return true;
};

/** 30 poslova po osobi = 1 krug u 30 sekundi → period = 900 / opterećenje */
export const MONKEY_ROTATION_JOBS_SECONDS_PRODUCT = 900;

/** Spori krug dok nema otvorenih poslova. */
export const MONKEY_IDLE_ROTATION_SECONDS = 120;

export const MONKEY_SPIN_PAUSED_KEY = 'spintasker_monkey_spin_paused';
export const MONKEY_SPIN_EVENT = 'spintasker-monkey-spin';

export const isWorkloadJob = (job) => {
  if (!job) return false;
  return !WORKLOAD_CLOSED_STATUSES.includes(job.status);
};

export const countWorkloadJobs = (jobs) => {
  if (!Array.isArray(jobs)) return 0;
  return jobs.filter(isWorkloadJob).length;
};

const isActiveMember = (person) => {
  if (!person) return false;
  if (person.active === false) return false;
  const status = String(person.status || '').toLowerCase();
  if (status === 'inactive' || status === 'disabled' || status === 'archived') return false;
  return true;
};

/** Broj radnika i partnera koji dele opterećenje (najmanje 1). */
export const countWorkloadPeople = (workers = [], partners = []) => {
  const workerCount = (Array.isArray(workers) ? workers : []).filter(isActiveMember).length;
  const partnerCount = (Array.isArray(partners) ? partners : []).filter(isActiveMember).length;
  return {
    workers: workerCount,
    partners: partnerCount,
    people: Math.max(1, workerCount + partnerCount)
  };
};

export const getWorkloadPerPerson = (jobCount, peopleCount) => {
  const people = Math.max(1, Number(peopleCount) || 1);
  return (Number(jobCount) || 0) / people;
};

/**
 * Trajanje jednog kruga u sekundama, prema poslovima po osobi.
 * 15 po osobi → 60s, 30 → 30s, 60 → 15s, 90 → 10s.
 */
export const getMonkeyRotationDuration = (jobsPerPerson) => {
  const count = Number(jobsPerPerson) || 0;
  if (count <= 0) return MONKEY_IDLE_ROTATION_SECONDS;
  return MONKEY_ROTATION_JOBS_SECONDS_PRODUCT / count;
};

export const formatRotationSeconds = (duration) => {
  const value = Number(duration);
  if (!Number.isFinite(value)) return '—';
  if (Math.abs(value - Math.round(value)) < 0.05) {
    return String(Math.round(value));
  }
  return value.toFixed(1);
};

export const formatJobsPerPerson = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  if (Math.abs(n - Math.round(n)) < 0.05) return String(Math.round(n));
  return n.toFixed(1);
};

export const readMonkeySpinPaused = () => {
  if (typeof window === 'undefined') return false;
  return localStorage.getItem(MONKEY_SPIN_PAUSED_KEY) === 'true';
};

export const writeMonkeySpinPaused = (paused) => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(MONKEY_SPIN_PAUSED_KEY, paused ? 'true' : 'false');
  window.dispatchEvent(new CustomEvent(MONKEY_SPIN_EVENT, { detail: { paused: !!paused } }));
};
